import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card, CardContent } from "components/ui";

const UserDetailSkeleton = memo(() => {
  return (
    <div className="text-center">
      <div className="flex flex-col items-center gap-2 md:gap-3.5 py-4 lg:pt-1 lg:pb-20">
        <Skeleton variant="circular" width={100} height={100} />
        <div className="flex items-center gap-1.5">
          <Skeleton variant="text" width={140} height={28} />
          <Skeleton
            variant="rounded"
            width={64}
            height={24}
            sx={{ borderRadius: "999px" }}
          />
        </div>
        <Skeleton variant="text" width={220} height={22} />
      </div>

      <div className="flex gap-6 border-b px-2 pb-3">
        {Array.from({ length: 7 }, (_, index) => (
          <Skeleton key={index} variant="text" width={64} height={28} />
        ))}
      </div>

      <div className="my-5">
        <Card>
          <CardContent className="grid gap-5 py-5">
            {Array.from({ length: 4 }, (_, index) => (
              <Skeleton
                key={index}
                variant="rounded"
                width="100%"
                height={40}
              />
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
});

UserDetailSkeleton.displayName = "UserDetailSkeleton";

export default UserDetailSkeleton;
